export default "__VITE_ASSET__clnyB$xW__"